<template>
  <div>
    <counter :message="cMessage" :type="cType" class="mt-2 mb-2"></counter>
    <v-textarea
        v-model="holder"
        :rows="rows"
        :placeholder="label"
        :counter="counter"
        clearable
        :rules="rules"
        :required="required"
        @input="onInput"
    >
    </v-textarea>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Counter from '../Whatsapp/Counter.vue';

export default {
  name: 'WhatsappMessage',
  components: { Counter },
  props: {
    label: String,
    value: String,
    counter: Boolean,
    read: Boolean,
    required: { default: () => false },
    rows: {
      type: String,
      default: () => '12',
    },
    rules: {
      type: Array,
      default: () => [],
    },
    cMessage: String,
    readInfoHolder: String,
    cType: String,
    buttonDisabled: Boolean,
  },
  data: () => ({ holder: '', ct: '' }),
  methods: {
    onInput() {
      this.$emit('button:status', '');
      this.$emit('text:change', this.clean());
    },
    clean() {
      let msg = '';

      if (this.holder) {
        const k = this.holder.length;
        for (let i = 0; i < k; i += 1) {
          if (
              this.holder.charAt(i) === '1'
              || this.holder.charAt(i) === '2'
              || this.holder.charAt(i) === '3'
              || this.holder.charAt(i) === '4'
              || this.holder.charAt(i) === '5'
              || this.holder.charAt(i) === '6'
              || this.holder.charAt(i) === '7'
              || this.holder.charAt(i) === '8'
              || this.holder.charAt(i) === '9'
              || this.holder.charAt(i) === '0'
              || this.holder.charAt(i) === 'Q'
              || this.holder.charAt(i) === 'W'
              || this.holder.charAt(i) === 'E'
              || this.holder.charAt(i) === 'R'
              || this.holder.charAt(i) === 'T'
              || this.holder.charAt(i) === 'Y'
              || this.holder.charAt(i) === 'U'
              || this.holder.charAt(i) === 'I'
              || this.holder.charAt(i) === 'O'
              || this.holder.charAt(i) === 'P'
              || this.holder.charAt(i) === 'A'
              || this.holder.charAt(i) === 'S'
              || this.holder.charAt(i) === 'D'
              || this.holder.charAt(i) === 'F'
              || this.holder.charAt(i) === 'G'
              || this.holder.charAt(i) === 'H'
              || this.holder.charAt(i) === 'J'
              || this.holder.charAt(i) === 'K'
              || this.holder.charAt(i) === 'L'
              || this.holder.charAt(i) === 'Z'
              || this.holder.charAt(i) === 'X'
              || this.holder.charAt(i) === 'C'
              || this.holder.charAt(i) === 'V'
              || this.holder.charAt(i) === 'B'
              || this.holder.charAt(i) === 'N'
              || this.holder.charAt(i) === 'M'
              || this.holder.charAt(i) === 'q'
              || this.holder.charAt(i) === 'w'
              || this.holder.charAt(i) === 'e'
              || this.holder.charAt(i) === 'r'
              || this.holder.charAt(i) === 't'
              || this.holder.charAt(i) === 'y'
              || this.holder.charAt(i) === 'u'
              || this.holder.charAt(i) === 'i'
              || this.holder.charAt(i) === 'o'
              || this.holder.charAt(i) === 'p'
              || this.holder.charAt(i) === 'a'
              || this.holder.charAt(i) === 's'
              || this.holder.charAt(i) === 'd'
              || this.holder.charAt(i) === 'f'
              || this.holder.charAt(i) === 'g'
              || this.holder.charAt(i) === 'h'
              || this.holder.charAt(i) === 'j'
              || this.holder.charAt(i) === 'k'
              || this.holder.charAt(i) === 'l'
              || this.holder.charAt(i) === 'z'
              || this.holder.charAt(i) === 'x'
              || this.holder.charAt(i) === 'c'
              || this.holder.charAt(i) === 'v'
              || this.holder.charAt(i) === 'b'
              || this.holder.charAt(i) === 'n'
              || this.holder.charAt(i) === '$'
              || this.holder.charAt(i) === 'm'
              || this.holder.charAt(i) === 'Ğ'
              || this.holder.charAt(i) === 'ğ'
              || this.holder.charAt(i) === 'Ş'
              || this.holder.charAt(i) === 'ş'
              || this.holder.charAt(i) === 'Ü'
              || this.holder.charAt(i) === 'ü'
              || this.holder.charAt(i) === 'İ'
              || this.holder.charAt(i) === 'ı'
              || this.holder.charAt(i) === 'Ç'
              || this.holder.charAt(i) === 'ç'
              || this.holder.charAt(i) === 'Ö'
              || this.holder.charAt(i) === 'ö'
              || this.holder.charAt(i) === '='
              || this.holder.charAt(i) === ' '
              || this.holder.charAt(i) === '/'
              || this.holder.charAt(i) === '!'
              || this.holder.charAt(i) === '#'
              || this.holder.charAt(i) === '+'
              || this.holder.charAt(i) === '%'
              || this.holder.charAt(i) === '{'
              || this.holder.charAt(i) === '}'
              || this.holder.charAt(i) === '['
              || this.holder.charAt(i) === ']'
              || this.holder.charAt(i) === '('
              || this.holder.charAt(i) === ')'
              || this.holder.charAt(i) === '?'
              || this.holder.charAt(i) === '*'
              || this.holder.charAt(i) === '-'
              || this.holder.charAt(i) === '€'
              || this.holder.charAt(i) === '_'
              || this.holder.charAt(i) === '@'
              || this.holder.charAt(i) === '|'
              || this.holder.charAt(i) === ','
              || this.holder.charAt(i) === '.'
              || this.holder.charAt(i) === ':'
              || this.holder.charAt(i) === ';'
              || this.holder.charAt(i) === '$'
              || this.holder.charAt(i) === '£'
              || this.holder.charAt(i) === '¥'
              || this.holder.charAt(i) === 'é'
              || this.holder.charAt(i) === 'ù'
              || this.holder.charAt(i) === 'ò'
              || this.holder.charAt(i) === 'Å'
              || this.holder.charAt(i) === 'ß'
              || this.holder.charAt(i) === '"'
              || this.holder.charAt(i) === '¤'
              || this.holder.charAt(i) === '&'
              || this.holder.charAt(i) === "'"
              || this.holder.charAt(i) === '<'
              || this.holder.charAt(i) === '>'
              || this.holder.charAt(i) === '~'
              || this.holder.charAt(i) === '^'
              || this.holder.charAt(i) === '\\'
              || this.holder.charAt(i) === 'Ä'
              || this.holder.charAt(i) === 'Ñ'
              || this.holder.charAt(i) === '§'
              || this.holder.charAt(i) === '\r'
              || this.holder.charAt(i) === '\n'
          ) {
            msg += this.holder.charAt(i);
          }
        }
      }

      return msg;
    },
  },
  watch: {
    value(nv) {
      this.holder = nv;
    },
    read() {
      this.onInput();
    },
  },
};
</script>
